import {
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Table,
  Tabs,
} from 'antd';
import type { Moment } from 'moment';
import React, { useState } from 'react';

import {
  CHECK_IN_TABLE_COLUMNS,
  DUMMY_CHECK_IN_TABLE_DATA,
  PROGRAM_OPTIONS,
} from './constants';
import styles from './index.module.scss';

const { Item, useForm } = Form;

type ExportQrcodeFormValues = {
  date: Moment;
  name: string;
};

export const PageContent = () => {
  const [form] = useForm<ExportQrcodeFormValues>();

  const [showExportQrcodeModal, setShowExportQrcodeModal] = useState(false);

  const closeModal = () => {
    form.resetFields();
    setShowExportQrcodeModal(false);
  };

  const onExportQrcodeFormFinish = (formValues: ExportQrcodeFormValues) => {
    console.log('formValues:', formValues);
    // TODO: 邏輯待寫
  };

  return (
    <>
      <Space direction="vertical" size="middle" className="w-full">
        <Space direction="vertical" className="w-full">
          <Button onClick={() => setShowExportQrcodeModal(true)}>
            匯出簽到Qrcode
          </Button>

          <Space size="middle" align="baseline">
            <Space size={0} align="baseline">
              <p>日期：</p>
              <DatePicker
                format="YYYY/MM/DD"
                placeholder="活動日期"
                className={styles.filterWidth}
              />
            </Space>
            <Space size={0} align="baseline">
              <p>課程：</p>
              <Select
                allowClear
                placeholder="請選擇課程名稱"
                options={PROGRAM_OPTIONS}
                className={styles.filterWidth}
              />
            </Space>
            <Space size={0} align="baseline">
              <p>會員：</p>
              <Input
                allowClear
                placeholder="例如：0987789987"
                className={styles.filterWidth}
              />
            </Space>
          </Space>
        </Space>

        {/* TODO: 簽到紀錄 表格 */}
        <Tabs
          items={[
            {
              label: '簽到紀錄',
              key: '簽到紀錄',
              children: (
                <Card>
                  <Table
                    bordered
                    rowKey="_id"
                    scroll={{ x: 'max-content' }}
                    columns={CHECK_IN_TABLE_COLUMNS}
                    dataSource={DUMMY_CHECK_IN_TABLE_DATA}
                  />
                </Card>
              ),
            },
          ]}
        />
      </Space>

      <Modal
        title="匯出簽到Qrcode"
        open={showExportQrcodeModal}
        centered
        destroyOnClose
        onCancel={closeModal}
        okText="匯出"
        onOk={form.submit}
      >
        <Form form={form} layout="vertical" onFinish={onExportQrcodeFormFinish}>
          <Item
            label="育樂日期"
            name="date"
            rules={[{ required: true, message: '必填欄位' }]}
          >
            <DatePicker placeholder="請選擇日期" format="YYYY/MM/DD" />
          </Item>

          <Item
            label="育樂名稱"
            name="name"
            rules={[{ required: true, message: '必填欄位' }]}
          >
            <Select placeholder="從選單選擇" options={PROGRAM_OPTIONS} />
          </Item>
        </Form>
      </Modal>
    </>
  );
};
